import {
  CONTROL_AREA_HEIGHT_PERCENT,
  CONTROL_AREA_HEIGHT,
  DATA_SWIPE_ATTR
} from './constants';

export const isInVideoControlArea = (
  target: EventTarget | null,
  clientY: number
): boolean => {
  if (!(target instanceof HTMLVideoElement)) {
    return false;
  }

  const rect = target.getBoundingClientRect();
  const relativeY = clientY - rect.top;
  const controlAreaHeight = Math.min(
    CONTROL_AREA_HEIGHT,
    rect.height * CONTROL_AREA_HEIGHT_PERCENT
  );

  return relativeY > rect.height - controlAreaHeight;
};

export const isNavButton = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) {
    return false;
  }
  return !!target.closest('button');
};

export const getSwipeTarget = (container: HTMLElement): HTMLElement | null => {
  return container.querySelector(`[${DATA_SWIPE_ATTR}]`);
};

export const getElementWidth = (element: HTMLElement): number => {
  const target = getSwipeTarget(element);

  if (!target) {
    return window.innerWidth;
  }

  return target.getBoundingClientRect().width;
};
